<template>
    <pictureM></pictureM>
</template>

<script>
    import pictureM from '@/components/picture'
    export default{
        components:{
            pictureM
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/picture/picture_tab.vue